import { BalanceTraceChart } from '../../core/entities/general/BalanceTraceChart.entity';
import { BalanceTraceResponse } from '../interfaces/balance-trace.interface';

export class BalanceTraceMapper {
  static fromResponseToEntity(
    response: BalanceTraceResponse
  ): BalanceTraceChart {
    return new BalanceTraceChart(
      response.currentBalance,
      response.averageBalance,
      response.historical
    );
  }
}
